import { useState, useEffect } from "react";
import apibig from "../components/Apibig"; // Ajusta la ruta si es necesario

const useModalModulo = (initialForm) => {
  const [formmodulos, setFormmodulos] = useState(initialForm);
  const [errorsmodulos, setErrorsmodulos] = useState({});
  const [loadingmodulos, setLoadingmodulos] = useState(false);
  const [responsemodulos, setResponsemodulos] = useState(null);

  // Resetear formulario al cambiar initialForm (nuevo o edición)
  useEffect(() => {
    setFormmodulos(initialForm);
    setErrorsmodulos({});
    setResponsemodulos(null);
  }, [initialForm]);

  // Manejo de cambios (input/select/checkbox)
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    let val = type === "checkbox" ? checked : value;

    // Asegurar booleano real para campo 'Win'
    if (name === "Win") {
      val = value === "true" || val === true;
    }

    setFormmodulos((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  // Enviar datos a la API (crear o actualizar)
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const autusuario = JSON.parse(sessionStorage.getItem("data"));

    if (!autusuario || !autusuario.appid || !autusuario.basedatos) {
      console.error("No se encontraron credenciales válidas en la sesión.");
      return null;
    }

    const payload = {
      appid: autusuario.appid,
      basedatos: autusuario.basedatos,
      formmodulos: {
        ...formmodulos,
        Win: !!formmodulos.Win, // Forzar booleano real
      },
    };

    try {
      setLoadingmodulos(true);

      const endpoint =
        !formmodulos.Id || formmodulos.Id === 0
          ? "/api/roles/addmodulo"
          : "/api/roles/updatemodulo";

      const res = await apibig.post(endpoint, payload);

      // console.log("Payload enviado:", payload);
      // console.log("Respuesta API:", res.data);

      setResponsemodulos(res.data);
      return res.data;
    } catch (error) {
      console.error("Error al guardar el módulo:", error);
      setResponsemodulos(null);
      return null;
    } finally {
      setLoadingmodulos(false);
    }
  };

  // Reset manual del formulario
  const resetForm = () => {
    setFormmodulos(initialForm);
    setErrorsmodulos({});
    setResponsemodulos(null);
  };

  // Validación por campo (puedes implementarla)
  const handleBlur = (e) => {
    // Implementa validaciones por campo si quieres
  };

  return {
    formmodulos,
    errorsmodulos,
    loadingmodulos,
    responsemodulos,
    handleChange,
    handleSubmit,
    resetForm,
    handleBlur,
    setFormmodulos,
  };
};

export default useModalModulo;
